import React from "react";
import { Field } from "formik";
import CustomInputTextComponent from "components/Form/CustomInputTextComponent";
import { Checkbox } from "components/Form/SpecialButtons";

const GeneralForm = ({ element }) => (
	<div>
		<Field type="text" name="label" customlabel="Libellé du code Réponse" component={CustomInputTextComponent} required />
		<Field type="text" name="code" customlabel="Code Réponse" component={CustomInputTextComponent} required />
		<Field type="text" name="sil_code" customlabel="Code SIL" component={CustomInputTextComponent} required />
		<Field type="text" name="code_comment" customlabel="Commentaire" component={CustomInputTextComponent} />
		<Field type="text" name="group" customlabel="Regroupement" component={CustomInputTextComponent} />
		<Field customlabel="Texte libre" component={Checkbox} name="add_text" id="add_text" />
	</div>
);

export default GeneralForm;
